<template>
  <v-container>
    <v-row>
      <v-col>
        <h3>A cada 10 propostas, quantas vendas são fechadas?</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Insira a quantidade"
          v-model="fechadasPorProposta"
          type="number"
          min="0"
          v-on:input="emitInputChange('fechadasPorProposta', fechadasPorProposta)"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h3>A cada 10 demonstrações, quantas propostas são geradas?</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Insira a quantidade"
          v-model="propostasPorDemo"
          type="number"
          min="0"
          v-on:input="emitInputChange('propostasPorDemo', propostasPorDemo)"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <h3>Para realizar 1 demonstração qual quantidade de leads devem ser contactados?</h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Insira a quantidade"
          v-model="demoPorLead"
          type="number"
          min="0"
          v-on:input="emitInputChange('demoPorLead', demoPorLead)"
        ></v-text-field>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  data: function() {
    return {
      fechadasPorProposta: null,
      propostasPorDemo: null,
      demoPorLead: null,
    };
  },
  methods: {
    emitInputChange(fieldName, value) {
      this.$emit('input-change', fieldName, value);
    }
  }
};
</script>

<style>
</style>